// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ga-0";